const axios = require('axios');
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_DEV,
});

export const setupAuthInterceptor = (authInstance, axiosToUse) => {
  // Use the provided axios instance (which should be axiosInstance)
  axiosToUse.interceptors.request.use(
    async (config) => {
      const user = authInstance.currentUser; // Use the initialized auth instance

      if (user) {
        // Use the optimized getIdToken()
        const token = await user.getIdToken(); 
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        delete config.headers.Authorization;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default axiosInstance